<template>
    <div class="uk-container uk-container-small">
        <div class="uk-card uk-card-default uk-card-body uk-width-1-1@m mt-5">
            <div class=" uk-width-1-1@m">
                <h2 class="uk-modal-title">Creation de boutiques</h2> <br>
            <form @submit.prevent="createBoutiques">
            <fieldset class="uk-fieldset">
           <div uk-grid class="uk-margin ">
                <div class="uk-width-1-2">
                <input class="uk-input" type="text" v-model="boutique.nom_boutique" placeholder="Nom de l'entreprise" required>
            </div>
            <div class="uk-width-1-2">
                <input class="uk-input" type="text" v-model="boutique.nom_responsable" placeholder="Nom du responsable" required>
            </div>
           </div>
            <div class="uk-margin" uk-grid>
                <div class="uk-width-1-2">
                <input class="uk-input" type="text" v-model="boutique.adresse" placeholder="Situation géographique" required>
            </div>
            <div class="uk-width-1-2">
                <input class="uk-input" type="number" v-model="boutique.contact_boutique" placeholder="Numéro à contacter" required>
            </div>
            </div>
            <div class="uk-margin">
            <label >Type de paiement</label>
            <select v-model="boutique.type_paiement" class="uk-select">
                <option>Wave</option>
                <option>Orange money</option>
                <option>Moov money</option>
                <option>MTN money</option>
                <option>Espèces</option>
                <option>Virement Bancaire</option>
            </select>
            </div>
            <div class="uk-margin">
                <input class="uk-input" type="text" v-model="boutique.adresse_paiement" placeholder="Contact / Adresse de reception" required> 
            </div>

        </fieldset>
       <div class="d-flex justify-content-center">
            <button class="btn-round my-1 border-0 px-5 uk-button uk-button-primary" style=" color:#fff;  font-size:1em !important; ">Valider</button>
       </div>
        </form>
            </div>
        </div>
    </div>
</template>
<script>
    import { db, dbstore, auth } from '../../main';
    import Swal from "sweetalert2";
    import uid from "short-unique-id"
    export default {
    data(){
        return{
            boutique: {
                nom_boutique: "",
                nom_responsable: "",
                adresse: "",
                contact_boutique:"",
                type_paiement:"",
                adresse_paiement:"",
                id_proprio:"",
                uuid:"",
                created_at:""
            },
        }
        
    },
    methods: {
        createBoutiques(event){
            const id = auth.currentUser.uid
            const uuid = new uid({ length: 5 })
            const myuid = 'BT-' + uuid().toUpperCase()
            const current = new Date();
            const date = current.getFullYear()+'-'+(current.getMonth()+1)+'-'+current.getDate();
            const time = current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();
            const dateTime = date +' '+ time;
            const created_at = dateTime
            const bt = this.boutique
            dbstore.collection('boutiques').add({
                nom_boutique: bt.nom_boutique,
                nom_responsable: bt.nom_responsable,
                adresse: bt.adresse,
                contact_boutique:bt.contact_boutique,
                type_paiement:bt.type_paiement,
                adresse_paiement:bt.adresse_paiement,
                id_proprio:"",
                uuid:myuid,
                created_at:created_at,
                commercial_id:id
            })
            this.$router.push({ path: "/admin/boutiques"});
            event.target.reset();
            event.preventDefault();
            Swal.fire({
                position: "center",
                icon: "success",
                title: "Crée avec succès",
                showConfirmButton: true,
                timer: 4000,
                allowOutsideClick: false,
            });
        
        },

        checkForm: function (e) {
            if (this.nom_boutique && this.nom_responsable && this.adresse && this.contact_boutique && this.adresse_paiement) {
                return true;
            }

            this.errors = [];

            if (!this.nom_boutique) {
                this.errors.push('Veillez entrer uniquement des lettres.');
            }
            if (!this.nom_responsable) {
                this.errors.push('Veillez entrer uniquement des lettres.');
            }
            if (!this.adresse) {
                this.errors.push('Veillez entrer uniquement des lettres.');
            }
            if (!this.contact_boutique) {
                this.errors.push('Veillez entrer uniquement des chiffres.');
            }
            if (!this.adresse_paiement) {
                this.errors.push('Veillez entrer uniquement des chiffres.');
            }

            e.preventDefault();
        }
    }
}
</script>